import styled from 'styled-components';
import { TextAlignType } from 'shared/types/general';
import { IStylesProps } from './SubTitle.types';

export const Container = styled.p<IStylesProps>`
    font-weight: 400;
    font-size: ${({ size }) => size ?? '20px'};
    line-height: 1.6;
    text-align: ${({ textAlign }) => textAlign ?? TextAlignType.CENTER};
    color: ${({ color }) => color ?? '#4b5563'};
    margin: ${({ margin }) => margin ?? 0};
    max-width: ${({ maxWidth }) => `${maxWidth}px`};
    @media (max-width: 767px) {
        font-size: ${({ size }) => size ?? '16px'};
    }
`;
